<template>
    <div v-if="editor">
        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-light" @click="editor.chain().focus().toggleBold().run()" :class="{ 'btn-dark': editor.isActive('bold') }">
                {{ $trans.get('__JSON__.bold') }}
            </button>
            <button type="button" class="btn btn-sm btn-light" @click="editor.chain().focus().toggleItalic().run()" :class="{ 'btn-dark': editor.isActive('italic') }">
                {{ $trans.get('__JSON__.italic') }}
            </button>
            <button type="button" class="btn btn-sm btn-light" @click="editor.chain().focus().toggleStrike().run()" :class="{ 'btn-dark': editor.isActive('strike') }">
                {{ $trans.get('__JSON__.strike') }}
            </button>
            <button type="button" class="btn btn-sm btn-light" @click="editor.chain().focus().toggleUnderline().run()" :class="{ 'btn-dark': editor.isActive('underline') }">
                {{ $trans.get('__JSON__.underline') }}
            </button>
        </div>&nbsp;

        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-light" @click="editor.chain().focus().setParagraph().run()" :class="{ 'btn-dark': editor.isActive('paragraph') }">
                {{ $trans.get('__JSON__.paragraph') }}
            </button>
            <button type="button" class="btn btn-sm btn-light" @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
                {{ $trans.get('__JSON__.H1') }}
            </button>
            <button type="button" class="btn btn-sm btn-light" @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
                {{ $trans.get('__JSON__.H2') }}
            </button>
            <button type="button" class="btn btn-sm btn-light" @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
                {{ $trans.get('__JSON__.H3') }}
            </button>
        </div>&nbsp;

        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-light">
                {{ $trans.get('__JSON__.ul') }}
            </button>
            <button type="button" class="btn btn-sm btn-light">
                {{ $trans.get('__JSON__.ol') }}
            </button>
        </div>
    </div>

    <div id="editor">
        <editor-content :editor="editor" class="content" />
    </div>

    <button class="btn btn-primary" @click="save" :disabled="saving">
        {{ $trans.get('__JSON__.Save') }}
    </button>
</template>

<style lang="scss">
#editor {
    margin-top: 20px;
    margin-bottom: 20px;
}

.content {
    overflow-y: scroll;
    height: 400px;
}

/* Basic editor styles */
.ProseMirror {
    > * + * {
        margin-top: 0.75em;
    }

    height: 400px;
}
</style>

<script>
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import { Editor, EditorContent } from '@tiptap/vue-3'

export default {
    props: {
        document: {
            type: String,
            required: true,
        },
        version: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: true
        },
    },

    components: {
        EditorContent,
    },

    data() {
        return {
            saving: false,
            editor: null,
        }
    },

    methods: {
        save() {
            this.saving = true
            axios.post(`/admin/documents/${this.document}/versions/${this.version}`, {
                content: this.editor.getHTML(),
            })
                .then(response => window.toastr.success(this.$trans.get('__JSON__.Changes Saved'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .catch(error => window.toastr.error(error.response.data.message ?? this.$trans.get('__JSON__.Something went wrong'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .finally(() => this.saving = false)
        },
    },

    mounted() {
        this.editor = new Editor({
            content: this.content,
            editable: this.editable,
            autofocus: false,
            extensions: [
                StarterKit,
                Underline,
            ],
        })
    },

    beforeUnmount() {
        this.editor.destroy()
    },
}
</script>
